<app-radio-button-group [selectedIndex]="selectedScaleIndex" size="small" [ngClass]="{'disabled': disabled}">
  <app-radio-button-item (click)="selectedScaleChange.next(EnumScales.DAY)"
    [selected]="selectedScale === EnumScales.DAY" ga-event="GraphDay">
    <app-radio-button-label [text]="utilsService.capitalizeFirstLetter(scales[EnumScales.DAY].label | AsyncLang | async)"></app-radio-button-label>
  </app-radio-button-item>
  <app-radio-button-item (click)="selectedScaleChange.next(EnumScales.WEEK)"
    [selected]="selectedScale === EnumScales.WEEK" ga-event="GraphWeek">
    <app-radio-button-label [text]="utilsService.capitalizeFirstLetter(scales[EnumScales.WEEK].label | AsyncLang | async)"></app-radio-button-label>
  </app-radio-button-item>
  <app-radio-button-item (click)="selectedScaleChange.next(EnumScales.MONTH_DAILY)"
    [selected]="selectedScale === EnumScales.MONTH_DAILY" ga-event="GraphMonth">
    <app-radio-button-label [text]="utilsService.capitalizeFirstLetter(scales[EnumScales.MONTH_DAILY].label | AsyncLang | async)"></app-radio-button-label>
  </app-radio-button-item>
  <app-radio-button-item (click)="selectedScaleChange.next(EnumScales.YEAR)"
    [selected]="selectedScale === EnumScales.YEAR" ga-event="GraphYear">
    <app-radio-button-label [text]="utilsService.capitalizeFirstLetter(scales[EnumScales.YEAR].label | AsyncLang | async)"></app-radio-button-label>
  </app-radio-button-item>
</app-radio-button-group>
